import { useCallback } from 'react';

export const useOpenChat = () => useCallback(() => {
    if (!window.Communication) {
        return;
    }

    const api = window.Communication.API;
    const windowStatus = api?.chat.getWindowStatus();

    if (windowStatus?.activeScreen === 'CHAT_UI__ICON' || windowStatus?.hidden) {
        api?.inbox.minimize();
        api?.chat.maximize();
    }
}, []);
